import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from 'react-router-dom';

const ConsultingCoaching = () => {
    return (
        <div className="rn-splite-style">
            <div className="split-wrapper">
                <div style={{fontSize:'18px'}}
                    className="coaching-section" >
                    <h2>1-On-1 Coaching With Jahid Hasan (12 Months)</h2>
                    <p><strong>Have Jahid Hasan Be Your Personal Advisor for 12 Months and Push You to New Heights</strong></p>

                    {/* <button className='btn-default'>
                        <a href='#consultingform'>Add to Cart - 12,000,000 BDT</a>
                    </button> */}

                    <section style={{ marginTop: "30px" }}>
                        <h3>WHAT IS IT?</h3>
                        <p style={{lineHeight:'30px'}}>
                            The 1-On-1 Coaching with Jahid Hasan for 12 months is an exclusive service that transforms one of the most in-demand business minds in the world into your own personal advisor.
                            You’ll discover everything there is to know about launching codes, growth systems or growth codes, structuring life, business and income alignment, systemizing it, automating it, high-ticket offers, scaling a team and life, business & income – the SMART way – and creating a sustainable business.

                            Jahid Hasan will help you identify existing opportunities for expansion. He’ll give you proprietary strategies, tools, and tactics so you're able to streamline, innovate, and maximize your business’s full potential.<br/>

                            Anyone who’s keen to undertake 1-On-1 Coaching with Jahid Hasan for 12 months is in for a transformative business experience.<br/>

                            Every week we get requests for long-term consulting and coaching. But it’s impossible to take on all of them because then Jahid Hasan will have no business left to run. Also...<br/>

                            The 1-On-1 Coaching spots are extremely limited in quantity, because we no longer accept everyone who can simply “pay” for it. There’s a qualification process you have to go through.<br/>

                            Not everyone’s built for an experience like this. Not everyone can go through 1-On-1 Coaching with Jahid Hasan for 12 months.<br/>

                            Truth is – some people are secretly addicted to their situation. They’ll smile, nod, and agree, but then do what they’ve always done. Effectively wasting their own time and Jahid’s when their spot could’ve been taken by someone else.<br/>

                            So if you’re actually <strong>SERIOUS</strong> about growth and have had a good think about it... Only then proceed forward with your 1-On-1 Coaching request.
                        </p>
                    </section>

                    <section style={{ marginTop: "30px" }}>
                        <h3>HOW CAN IT HELP?</h3>
                        <ul>
                            <li>Monthly 1-on-1 sessions with Jahid Hasan for 12 months (virtually)</li>
                            <li>Direct WhatsApp call access to Jahid for 12 months to ask any questions you want</li>
                        </ul>
                    </section>

                    <section style={{ marginTop: "30px" }}>
                        <h3>WHAT NOW?</h3>
                        <p>If you’d like to:</p>
                        <ul>
                            <li>Avoid common and not-so-common business mistakes to help you speed up the time it can take you to reach new business heights.</li>
                            <li>Receive a powerful action plan built specifically for your business that shows you areas of development to help you quickly realize outcomes.</li>
                            <li>Establish a unifying success framework for your life</li>
                        </ul>
                        <p>
                            Then the 1-On-1 Coaching with Jahid Hasan is for you.<br/><strong>We’ll see you on the other side.</strong></p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default ConsultingCoaching;
